import { observable } from "mobx";
import { Type } from "class-transformer";
import RefundVehicleResponse from "./refundVehicleResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class DistributorRefundChargeResponse {
  @observable
  chargeTypeId!: string;

  /**
   * Price list item Id.
   */
  @observable
  priceListItemId!: string;

  @observable
  @Type(() => RefundVehicleResponse)
  vehicle!: RefundVehicleResponse;

  @observable
  @Type(() => Date)
  validSince!: Date;

  @observable
  @Type(() => Date)
  validUntil!: Date;

  @observable
  price!: number;

  @observable
  officialRecordId?: string;

  @observable
  orderId!: string;

  @observable
  orderIdent!: number;

  @observable
  orderExternalId?: string;

  @observable
  salespointId!: string;

  @observable
  @Type(() => Date)
  orderConfirmedAt!: Date;
}
